import CreateChannelFooter from './CreateChannelFooter'

export default CreateChannelFooter
